import { render, staticRenderFns } from "./BioTestingCreateQuiz.vue?vue&type=template&id=c63aa404"
import script from "./BioTestingCreateQuiz.vue?vue&type=script&lang=js"
export * from "./BioTestingCreateQuiz.vue?vue&type=script&lang=js"
import style0 from "./BioTestingCreateQuiz.vue?vue&type=style&index=0&id=c63aa404&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports